import { Api } from "../api/Api";
import { paramIds } from "../api/ApiUtil";
import { AerialImage, ObbDet, ObbDetComp } from "../api/Application";
import { LoaderFunctionArgs } from "react-router-dom";

export interface DetectionLoaderData {
    image:    AerialImage;
    vehicles: ObbDet[];
}

export function parseCompressedObbDet( runId: number, x: ObbDetComp ): ObbDet {
    return {
        obbDetId:   x.id,
        obbRunId:   runId,
        obbModelId: 1,
        obbClassId: x.cls,
        x:          x.x,
        y:          x.y,
        width:      x.w,
        height:     x.h,
        angle:      x.a,
        confidence: x.c,
    };
}

export async function detectionLoader( { params }: LoaderFunctionArgs ): Promise<DetectionLoaderData> {
    const { aerialImageId = 10, runId = 4 } = paramIds( params );
    const aerialImg = await Api.aerialImageGet( aerialImageId );
    if( !aerialImg.isOk ) {
        throw new Error( "Failed to fetch image. Make sure you are logged in." );
    }
    const result = await Api.obbRunObjectList( runId );
    if( !result.isOk ) {
        throw new Error( result.error || "Failed to fetch abandoned vehicles." );
    }
    const image    = aerialImg.value; 
    const vehicles = result.value;    
    const ret = { 
        image:    image,
        vehicles: vehicles.map( v => parseCompressedObbDet( runId, v ) )
    };
    return ret;
}